export default "__VITE_ASSET__bEh5oXeb__"